import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { get } from '../lib/api';
import TopBar from '../components/layout/TopBar';
import SectionCard from '../components/widgets/SectionCard';
import { fmtBRL, fmtPct } from '../lib/format';
import { FileBarChart2 } from 'lucide-react';

export default function DRE() {
  const { competence, companyFilter, companies } = useApp();
  const [dreData, setDreData] = useState([]);

  useEffect(() => {
    (async () => {
      const list = companyFilter === 'all'
        ? companies
        : companies.filter((c) => c.id === companyFilter);

      const results = await Promise.all(
        list.map(async (co) => {
          const d = await get('/dre', { competence, company_id: co.id });
          return { company: co, ...d };
        })
      );

      // Add consolidado se vendo all
      if (companyFilter === 'all') {
        const consolidated = await get('/dre', { competence });
        results.push({ company: { id: '__cons__', name: 'CONSOLIDADO GRUPO', color: '#D4AF37' }, ...consolidated });
      }
      setDreData(results);
    })();
  }, [competence, companyFilter, companies]);

  const Row = ({ label, values, isHeader, isBold, isProfit, isSub }) => (
    <tr className={`${isHeader ? 'bg-zinc-900/60' : ''}`}>
      <td className={`${isSub ? 'pl-8' : ''} ${isBold ? 'font-semibold text-zinc-50' : 'text-zinc-300'} ${isHeader ? 'overline text-zinc-400' : ''}`}>
        {label}
      </td>
      {values.map((v, i) => (
        <td
          key={i}
          className={`text-right font-mono tabular-nums ${
            isBold ? 'font-semibold' : ''
          } ${isProfit ? (v >= 0 ? 'emerald-text' : 'red-text') : 'text-zinc-100'}`}
        >
          {typeof v === 'number' ? fmtBRL(v) : v}
        </td>
      ))}
    </tr>
  );

  return (
    <div className="fade-in">
      <TopBar title="DRE Gerencial" subtitle="Demonstração do Resultado do Exercício por competência" />
      <div className="px-8 py-7">
        <SectionCard padded={false} testid="dre-table">
          <div className="overflow-x-auto">
            <table className="w-full ceap-table">
              <thead>
                <tr>
                  <th>Conta</th>
                  {dreData.map((d) => (
                    <th key={d.company.id} className="text-right min-w-[180px]">
                      <div className="flex items-center justify-end gap-2">
                        <span className="w-2 h-2 rounded-full" style={{ background: d.company.color || '#D4AF37' }} />
                        <span className="text-zinc-200 normal-case tracking-normal font-medium">{d.company.name}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <Row label="RECEITA OPERACIONAL BRUTA" values={dreData.map((d) => d.receita)} isHeader isBold />
                <Row label="(-) Custos" values={dreData.map((d) => -Math.abs(d.custos))} isSub />
                <Row label="= LUCRO BRUTO" values={dreData.map((d) => d.lucro_bruto)} isBold isProfit />
                <Row label="(-) Despesas Operacionais" values={dreData.map((d) => -Math.abs(d.despesas))} isSub />
                <Row label="= LUCRO OPERACIONAL (EBITDA)" values={dreData.map((d) => d.lucro_operacional)} isBold isProfit />
                <Row label="(-) Impostos" values={dreData.map((d) => -Math.abs(d.impostos))} isSub />
                <Row label="= LUCRO LÍQUIDO" values={dreData.map((d) => d.lucro_liquido)} isBold isProfit />
                <Row label="(-) Investimentos" values={dreData.map((d) => -Math.abs(d.investimentos))} isSub />
                <Row label="= LUCRO LÍQUIDO REAL" values={dreData.map((d) => d.lucro_liquido_real)} isBold isProfit />
                <Row label="MARGEM BRUTA" values={dreData.map((d) => fmtPct(d.margem_bruta))} />
                <Row label="MARGEM LÍQUIDA" values={dreData.map((d) => fmtPct(d.margem_liquida))} />
              </tbody>
            </table>
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
